import React from 'react';
import {
  FooterContainer,
  FooterContent,
  Copyright,
  FooterLinks,
  FooterLink,
} from './Footer.styles';

export interface FooterProps {
  onNavigateLegal?: (page: 'privacy' | 'terms' | 'help') => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigateLegal }) => {
  return (
    <FooterContainer>
      <FooterContent>
        <Copyright>© {new Date().getFullYear()} Tvikla. All rights reserved.</Copyright>
        <FooterLinks>
          <FooterLink onClick={() => onNavigateLegal?.('privacy')}>Privacy</FooterLink>
          <FooterLink onClick={() => onNavigateLegal?.('terms')}>Terms</FooterLink>
          <FooterLink onClick={() => onNavigateLegal?.('help')}>Help Center</FooterLink>
        </FooterLinks>
      </FooterContent>
    </FooterContainer>
  );
};
